import { z } from 'zod'

import {
  WaitlistProducts,
  WaitlistSources,
} from '@scalar-org/entities/waitlist'

import type { RequestService } from '../request'

export function waitlistApiFactory(requestService: RequestService) {
  async function addToClientWaitlist(
    email: string,
    metadata: Record<string, string | number | boolean>,
  ) {
    return await requestService.request({
      url: 'core/waitlist',
      method: 'post',
      data: { email, products: [WaitlistProducts.Client], metadata },
      headers: {
        /** Source application. Will be used for header based filtering server side */
        'x-scalar-product': WaitlistSources.Client,
      },
      schema: z.null(),
    })
  }

  return {
    addToClientWaitlist,
  }
}
